"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Bucket_1 = require("./_Bucket");
exports._Buckets = {
    type: "list",
    member: {
        shape: _Bucket_1._Bucket,
        locationName: "Bucket"
    }
};
//# sourceMappingURL=_Buckets.js.map